import React from 'react';
import DevicesList from './components/DevicesList';

const DevicesView = () => (
  <DevicesList />
);

export default DevicesView;
